<template>
    <!-- Ventana del CRM (mismo diseño que la demo): Esc / clic afuera cierra,
         foco atrapado y devuelto al cerrar (lo hace CrmAnfitriones.vue). -->
    <div class="cr-md" @keydown="tecla">
        <div class="cr-md-bg" @click="cerrable && $emit('cerrar')"></div>
        <div ref="card" class="cr-md-card" role="dialog" aria-modal="true" :aria-labelledby="id" tabindex="-1" :style="{ '--mw': mw + 'px' }">
            <div class="cr-md-head">
                <div><h2 :id="id">{{ titulo }}</h2><p v-if="sub">{{ sub }}</p></div>
                <button v-if="cerrable" type="button" class="cr-ico-btn" :aria-label="T.close" @click="$emit('cerrar')" v-html="I.close"></button>
            </div>
            <div ref="body" class="cr-md-body"><slot /></div>
            <div v-if="$slots.pie" class="cr-md-foot"><slot name="pie" /></div>
        </div>
    </div>
</template>

<script>
import { I } from './crmUtil';
import T from './textos';
let n = 0;
// Ventanas abiertas (Esc cierra solo la de arriba).
export const PILA = [];

export default {
    name: 'CrmModal',
    props: {
        titulo: { type: String, default: '' },
        sub: { type: String, default: '' },
        mw: { type: Number, default: 560 },
        cerrable: { type: Boolean, default: true },
    },
    data() { return { I, T, id: 'crmd' + (++n) }; },
    mounted() {
        PILA.push(this);
        this._esc = e => { if (e.key === 'Escape' && PILA[PILA.length - 1] === this && this.cerrable) { e.preventDefault(); e.stopPropagation(); this.$emit('cerrar'); } };
        document.addEventListener('keydown', this._esc, true);
        this.$nextTick(() => {
            const f = this.$refs.card.querySelector('input:not([type=hidden]):not([type=radio]):not([type=checkbox]):not([type=file]), textarea, .cr-md-foot .cr-btn-main, .cr-md-foot .cr-btn-danger-main');
            (f || this.$refs.card).focus();
        });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this._esc, true);
        const i = PILA.indexOf(this); if (i >= 0) PILA.splice(i, 1);
    },
    methods: {
        tecla(e) {
            if (e.key !== 'Tab') return;
            const f = [...this.$refs.card.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex="0"]')].filter(x => x.offsetParent !== null);
            if (!f.length) return;
            const a = f[0], z = f[f.length - 1];
            if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
            else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
        },
    },
};
</script>
